<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13ucIw3/tc-custom/9780226086958.jpg?1732245287335" alt="This image is the cover for the book Timing & Turnout"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Timing & Turnout
      </h1>
      <p class="bookDescription body article font2">
        <p>Public policy in the United States is the product of decisions made by more than 500,000 elected officials, and the vast majority of those officials are elected on days other than Election Day. And because far fewer voters turn out for off-cycle elections, that means the majority of officials in America are elected by a politically motivated minority of Americans. Sarah F. Anzia is the first to systemically address the effects of election timing on political outcomes, and her findings are eye-opening.           <br/> The low turnout for off-cycle elections, Anzia argues, increases the influence of organized interest groups like teachers’ unions and municipal workers. While such groups tend to vote at high rates regardless of when the election is held, the low turnout in off-cycle years enhances the effectiveness of their mobilization efforts and makes them a proportionately larger bloc. Throughout American history, the issue of election timing has been a contentious one. Anzia’s book traces efforts by interest groups and political parties to change the timing of elections to their advantage, resulting in the electoral structures we have today. Ultimately, what might seem at first glance to be mundane matters of scheduling are better understood as tactics designed to distribute political power, determining who has an advantage in the electoral process and who will control government at the municipal, county, and state levels.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah F. Anzia
      </h2>
      
      <p class="authorDescription body article"><B>Sarah F. Anzia</B> is assistant professor of public policy at the Goldman School of Public Policy at the University of California, Berkeley. She lives in Berkeley, CA.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e9ddc956